/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'ai-summary-label': 'Riassumi',
  'copy-content-link-label': 'Copia il link',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Inizia a digitare per cercare un’etichetta',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Tutti',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Filtra la ricerca per prodotto',
  'dynamic-cards-search-page.atlas.for': 'per',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Calendario',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Partecipa alla riunione',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Link della riunione',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Partecipa alla riunione',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Eventi passati',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Evento ricorrente',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Ricorrente',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Prossimi eventi',
  'dynamic-cards-search-page.compass.owner-name': 'Di proprietà di {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Livello {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Trova contenuti',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Selezionato',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Suggerito',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Selezionato',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Suggerito',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Trova utenti',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Selezionato',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Trova etichette',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Trova gli spazi',
  'dynamic-cards-search-page.connect_third_party_product_description':
    'Connetti il tuo account per vedere i risultati mancanti',
  'dynamic-cards-search-page.connect_third_party_product_title': 'Il tuo amministratore ha aggiunto {product}!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} è ora disponibile!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end':
    'La data di inizio deve essere precedente alla data di fine',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': 'La data di inizio non può essere nel futuro',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': 'La data di fine non può essere nel futuro',
  'dynamic-cards-search-page.date.filter.last.month': 'Ultimi 30 giorni',
  'dynamic-cards-search-page.date.filter.last.week': 'Ultimi 7 giorni',
  'dynamic-cards-search-page.date.filter.last.year': 'Ultimo anno',
  'dynamic-cards-search-page.document-search-result.google-sheets-label': 'Fogli',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Genera la risposta',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Recenti',
  'dynamic-cards-search-page.error_primary': 'Si sono verificati problemi con la ricerca',
  'dynamic-cards-search-page.error_secondary':
    'Potrebbe essere un semplice contrattempo. La soluzione migliore è <btn>riprovare</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Persone esterne #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Cancella il filtro',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'Qualsiasi periodo',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'Ultimi 30 giorni',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'Ultimi 7 giorni',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Ultimo anno',
  'dynamic-cards-search-page.filter.last.updated.today': 'Oggi',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'Ieri',
  'dynamic-cards-search-page.filter.type.answer': 'Risposte',
  'dynamic-cards-search-page.filter.type.attachment': 'Allegati',
  'dynamic-cards-search-page.filter.type.blogpost': 'Post del blog',
  'dynamic-cards-search-page.filter.type.branch': 'Branch',
  'dynamic-cards-search-page.filter.type.calendar': 'Calendari',
  'dynamic-cards-search-page.filter.type.card': 'Scheda',
  'dynamic-cards-search-page.filter.type.comment': 'Commenti',
  'dynamic-cards-search-page.filter.type.commit': 'Commit',
  'dynamic-cards-search-page.filter.type.component': 'Componenti',
  'dynamic-cards-search-page.filter.type.conversation': 'Conversazioni',
  'dynamic-cards-search-page.filter.type.database': 'Database',
  'dynamic-cards-search-page.filter.type.design': 'Design',
  'dynamic-cards-search-page.filter.type.documents': 'Documenti',
  'dynamic-cards-search-page.filter.type.folder': 'Cartelle',
  'dynamic-cards-search-page.filter.type.issue': 'Ticket',
  'dynamic-cards-search-page.filter.type.message': 'Messaggi',
  'dynamic-cards-search-page.filter.type.page': 'Pagine',
  'dynamic-cards-search-page.filter.type.placeholder': 'Trova il tipo',
  'dynamic-cards-search-page.filter.type.presentation': 'Presentazioni',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pull request',
  'dynamic-cards-search-page.filter.type.question': 'Domande',
  'dynamic-cards-search-page.filter.type.repository': 'Repository',
  'dynamic-cards-search-page.filter.type.space': 'Spazi',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Calendari dello spazio',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Fogli di calcolo',
  'dynamic-cards-search-page.filter.type.video': 'Video',
  'dynamic-cards-search-page.filter.type.web-page': 'Pagine web',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Lavagne',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Cancella tutto',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filtro',
  'dynamic-cards-search-page.filters.names.content': 'Contenuti in',
  'dynamic-cards-search-page.filters.names.contributor': 'Collaboratore',
  'dynamic-cards-search-page.filters.names.labels': 'Etichetta',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Corrispondenza del titolo',
  'dynamic-cards-search-page.github-branch-result.label': 'Branch',
  'dynamic-cards-search-page.github-commit-result.label': 'Commit',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Pull request',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Trova i progetti',
  'dynamic-cards-search-page.landing_primary': 'Inizia applicando filtri alle schede dinamiche',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Documenti',
  'dynamic-cards-search-page.legacy-third-party-result.google-presentation-label': 'Presentazioni',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'Non sono stati trovati risultati corrispondenti alla ricerca',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Sembra che tu abbia applicato alcuni filtri. Potresti provare a cancellarli.',
  'dynamic-cards-search-page.nouns.goal': 'Obiettivo',
  'dynamic-cards-search-page.nouns.goals': 'Obiettivi',
  'dynamic-cards-search-page.nouns.tag': 'Tag',
  'dynamic-cards-search-page.nouns.tags': 'Tag',
  'dynamic-cards-search-page.number_of_results':
    'Visualizzazione di {numberOfResults,number} risultati su {totalCount,number}',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': 'Autorizzazione per {product} non riuscita.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'Autorizzazione per {product} riuscita.',
  'dynamic-cards-search-page.oauth-message-connect': 'Connetti',
  'dynamic-cards-search-page.products.custom-website': 'Pagina web',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Ordina per data di creazione (più recente)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Data di creazione (più recente)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Data di aggiornamento (più recente)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected':
    'Ordina per data di aggiornamento (più recente)',
  'dynamic-cards-search-page.results-sort.sort-options.label': "Cambia l'ordinamento dell'elenco",
  'dynamic-cards-search-page.rovo-onboarding-done': 'Fine',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Avanti',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Applica un filtro per prodotto per ottenere risultati della ricerca più pertinenti.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'Cerca in tutti gli spazi di lavoro della tua azienda',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'Per aiutarti a ottenere risultati specifici, queste opzioni cambiano a seconda del prodotto in base al quale stai filtrando i risultati.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Trova esattamente quello che stai cercando',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Allegato',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Allegato il {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Audio',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Immagine',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Aggiornato il {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Canale privato',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Icona di rimozione della ricerca recente',
  'dynamic-cards-search-page.search-result.repository-label': 'Repository',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Messaggio di gruppo con utenti esterni} =2 {{name1} e {name2}} =3 {{name1}, {name2} e {name3}} =4 {{name1}, {name2}, {name3} e {overflowContributorCount} altro} one {{name1}} other {{name1}, {name2}, {name3} e altri {overflowContributorCount}}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'canale-sconosciuto',
  'dynamic-cards-search-page.search_result_type_answer': 'Risposta',
  'dynamic-cards-search-page.search_result_type_component': 'Componente',
  'dynamic-cards-search-page.search_result_type_document': 'Documento',
  'dynamic-cards-search-page.search_result_type_embed': 'Link intelligente',
  'dynamic-cards-search-page.search_result_type_folder': 'Cartella',
  'dynamic-cards-search-page.search_result_type_presentation': 'Presentazione',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pull request',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'Documento SharePoint',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Calendario dello spazio',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Foglio di calcolo',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Non riconosciuto',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'Il tuo amministratore ha aggiunto <strong>{product}</strong>.{br} Connetti il tuo account per vedere i risultati mancanti, compresi i documenti a cui solo tu hai accesso.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} è ora disponibile!</strong>{br} Connetti il tuo account per vedere i risultati mancanti, compresi i documenti a cui solo tu hai accesso.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Autorizza',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': 'Autorizzazione per {product} non riuscita.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': 'Autorizzazione per {product} riuscita.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filtra per tutte le app',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filtra per più app',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Archiviato',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'A rischio',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Annullato',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Completato',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'In ritardo',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'Puntuale',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'In pausa',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'In sospeso',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} capitolo in questo video} other {{chapterCount,number} capitoli in questo video}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'icona del video',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Miniatura del video',
  'dynamic-cards-search-page.work-item-assignee.assigned': "è l'assegnatario",
  'dynamic-cards-search-page.work-item-creator.created': "è l'autore",
  'dynamic-cards-search-page.work-item-status.for': 'per',
  'dynamic-cards-search-page.work-item-task.label': 'Task',
  'dynamic-cards-search-page.work-item-ticket.label': 'Ticket',
  'dynamic-cards-search-page.work-item.label': 'Ticket',
  'initialsAvatar.label': 'Avatar iniziali',
  'personAvatar.label': 'Avatar persona',
  'search-page.results.private-result-label': 'Privato',
  'search-page.results.private-result-tooltip': 'Visibile solo a te',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} membro} other {{memberCount,number} membri}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Canale',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Canale',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} membro} other {{count,number} membri}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Ultima attività: {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'canale-sconosciuto',
  'search-page.results.product-results.third-party.external-people-label': 'Persone esterne',
  'search-page.results.product-results.third-party.external-person-label': 'Persona esterna',
  'search-page.results.product-results.third-party.last-active': 'Ultima attività: {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Messaggio',
  'search-page.results.product-results.third-party.no-contributors-label': 'Persone esterne in #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} in una conversazione privata',
  'search-page.results.product-results.third-party.thread-type-label': 'Thread',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} in #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} e {remainingContributorsCount} altro} other {{title} e altri {remainingContributorsCount}}}',
  'search-page.results.restricted-result-label': 'Con restrizioni',
  'search-page.results.restricted-result-tooltip': 'Visibile solo a persone specifiche',
  'search-page.show-more-breadcrumbs-button-label': 'Mostri altri breadcrumb',
  'search-page.verified-icon-label': 'Verificato',
  'search-page.verified-icon-tooltip-message':
    'Questa pagina è stata verificata da un responsabile o da un amministratore.',
  'search-result.result.count': '{count, plural, one {{count} risultato mostrato} other {{count} risultati mostrati}}',
  'search-result.user-mention.external-person': 'Persona esterna',
};
